import classNames from 'classnames';
import { IButton } from './IButton';

interface IPrimaryButton extends IButton {
  hideBgGradient?: boolean;
  className?: string;
}

const PrimaryButton = (props: IPrimaryButton) => {
  const {
    handleOnClick,
    children,
    width,
    disabled,
    hidden,
    hideBgGradient = false,
    className,
    type,
    height,
  } = props;

  return (
    <button
      type={type}
      style={{ width: width || 'auto', height: height || 'auto' }}
      className={classNames(
        { '!h-fit': !height },
        'rounded-full px-2 py-2 font-normal !leading-none text-white transition-shadow ease-in hover:shadow-md md:px-4 lg:px-6',
        { 'bg-gradient-to-t from-secondary to-primary': !hideBgGradient },
        { 'bg-primary': hideBgGradient },
        'disabled:cursor-not-allowed disabled:bg-gray-500 disabled:from-gray-400 disabled:to-gray-500 disabled:opacity-60 disabled:shadow-none disabled:hover:shadow-none',
        className
      )}
      onClick={handleOnClick}
      disabled={disabled}
      hidden={hidden}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
